<template>
  <v-form>
    <v-row v-if="$can('projects.members.manage.clients')">
      <v-col>
        <v-autocomplete
          outlined
          deletable-chips
          hide-details
          chips
          multiple
          auto-select-first
          :no-data-text="inputLoadingText"
          :loading="loading.users"
          v-model="selectedClients"
          :items="availableClients"
          item-text="name"
          item-value="id"
          label="Clients"
        >
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row v-if="$can('projects.members.manage.managers')">
      <v-col>
        <v-autocomplete
          outlined
          deletable-chips
          hide-details
          chips
          multiple
          auto-select-first
          :no-data-text="inputLoadingText"
          :loading="loading.users"
          v-model="selectedManagers"
          :items="availableManagers"
          item-text="name"
          item-value="id"
          label="Managers"
        >
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row v-if="$can('projects.members.manage.workers')">
      <v-col>
        <v-autocomplete
          outlined
          deletable-chips
          hide-details
          chips
          multiple
          auto-select-first
          :no-data-text="inputLoadingText"
          :loading="loading.users"
          v-model="selectedWorkers"
          :items="availableWorkers"
          item-text="name"
          item-value="id"
          label="Workers"
        >
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-col align="right">
        <v-btn
          depressed
          color="primary"
          @click="submit"
          :loading="membersLoading"
          :disabled="
            !selectedClients.length &&
              !selectedManagers.length &&
              !selectedWorkers.length
          "
          >Save</v-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ProjectAssignMembersForm',
  data: () => ({
    selectedClients: [],
    selectedManagers: [],
    selectedWorkers: []
  }),
  computed: {
    ...mapState('projects', ['project', 'membersLoading']),
    ...mapState('users', ['users', 'loading']),
    inputLoadingText() {
      return this.loading.users
        ? 'Loading users...'
        : 'No users available to assign.'
    },
    selectedMemberIDs() {
      return [].concat(
        this.selectedClients,
        this.selectedManagers,
        this.selectedWorkers
      )
    },
    existingMemberIDs() {
      return this.project.members.map(member => member.id)
    },
    availableClients() {
      return this.users.filter(user => {
        return (
          user.roles.includes('client') &&
          !this.existingMemberIDs.includes(user.id)
        )
      })
    },
    availableManagers() {
      return this.users.filter(user => {
        return (
          user.roles.includes('manager') &&
          !this.existingMemberIDs.includes(user.id)
        )
      })
    },
    availableWorkers() {
      return this.users.filter(user => {
        return (
          user.roles.includes('worker') &&
          !this.existingMemberIDs.includes(user.id)
        )
      })
    }
  },
  methods: {
    ...mapActions('projects', ['updateProjectMembers']),
    submit() {
      this.updateProjectMembers({
        id: this.project.id,
        members: this.selectedMemberIDs
      })

      this.selectedClients = []
      this.selectedManagers = []
      this.selectedWorkers = []
    }
  }
}
</script>
